/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {DateToddmmyyyyFormat} from '../../../../data/factory';
import {InputAutocompletion} from '../../../components/Inputs/InputAutocompletion';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../components/Inputs/InputField';
import {InputImage} from '../../../components/Inputs/InputImage';
import {TitleLabels} from '../../../../data/constants/Sinistres/famille';
import {useForm} from '../../../../hooks/Sinistres/useFormFamille';
import SecondaryButton from '../../../components/Button/SecondaryButton';
import { Validation } from '../../../../common/utils/validationSinistreFamille';

export const Form = (props: any) => {
  const {
    data,
    listAgence,
    onCancelForm,
    onSubmitForm,
    listContrat,
    isRedirection,
    listContratSvg,
  } = props;
  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
    listContrat,
    listContratSvg,
  );

  function handleCancel() {
    onCancelForm();
  }
  
  function handleSave() {
    if (dto.data.dateSinistre instanceof Date) {
      dto.data.dateSinistre = DateToddmmyyyyFormat(dto.data.dateSinistre);
    }
    onSubmitForm(dto.data);
  }
  return (
    <View>
      {/** form inputs */}
      <View>
        <InputAutocompletion
          label={TitleLabels.infos.numeroContrat}
          required
          data={listContrat}
          name="numeroContrat"
          value={values.numeroContrat ? values.numeroContrat : ''}
          onChange={handleChange}
          error={errors.numeroContrat}
          showError={showErrors.numeroContrat}
          maxLength={70}
          isEditable={!isRedirection}
        />
        <InputField
          label={TitleLabels.infos.nomDeclarant}
          required
          value={values.nomDeclarant}
          name="nomDeclarant"
          onChange={handleChange}
          error={errors.nomDeclarant}
          showError={showErrors.nomDeclarant}
          maxLength={70}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.nomContractant}
          required
          value={values.nomContractant}
          name="nomContractant"
          onChange={handleChange}
          error={errors.nomContractant}
          showError={showErrors.nomContractant}
          maxLength={70}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.telephone}
          required
          name="telephone"
          type="telephone"
          value={values.telephone}
          onChange={handleChange}
          error={errors.telephone}
          showError={showErrors.telephone}
          isEditable={false}
        />
        <InputDatePicker
          label={TitleLabels.infos.dateSinistre}
          required
          value={values.dateSinistre}
          name="dateSinistre"
          onChange={handleChange}
          error={errors.dateSinistre}
          showError={showErrors.dateSinistre}
          todayDate={true}
        />
        <InputField
          label={TitleLabels.infos.lieuSinistre}
          required
          value={values.lieuSinistre}
          name="lieuSinistre"
          onChange={handleChange}
          error={errors.lieuSinistre}
          showError={showErrors.lieuSinistre}
          maxLength={70}
          isEditable={true}
        />
        <InputAutocompletion
          label={TitleLabels.infos.agence}
          required
          data={listAgence}
          name="agence"
          value={values.agence}
          onChange={handleChange}
          error={errors.agence}
          showError={showErrors.agence}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.circonstanceAccident}
          required
          type="textArea"
          value={values.circonstanceAccident}
          name="circonstanceAccident"
          onChange={handleChange}
          error={errors.circonstanceAccident}
          showError={showErrors.circonstanceAccident}
          maxLength={1000}
          isEditable={true}
        />
        <InputImage
          label={TitleLabels.infos.photo}
          required
          value={values.photo}
          name="photo"
          onChange={handleChange}
          error={errors.photo}
          showError={showErrors.photo}
          maxLength={5}
          isEditable={true}
        />
        <InputImage
          label={TitleLabels.infos.pieceJointeAgence}
          value={values.pieceJointeAgence}
          name="pieceJointeAgence"
          onChange={handleChange}
          error={errors.pieceJointeAgence}
          showError={showErrors.pieceJointeAgence}
          maxLength={5}
          isFile={true}
        />
        <InputField
          label={TitleLabels.infos.estimationPrejudice}
          value={values.estimationPrejudice}
          name="estimationPrejudice"
          onChange={handleChange}
          error={errors.estimationPrejudice}
          showError={showErrors.estimationPrejudice}
          maxLength={70}
          isEditable={true}
        />
      </View>
      {/** Submit buttons */}
      <View>
        <SecondaryButton
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Demander prise en compte"
        />
      </View>
    </View>
  );
};
